export const managementParentId = (record, classById, parentKey = 'courseId') => String(classById.get(String(record.classId || ''))?.[parentKey] || (parentKey === 'courseId' ? record.education?.courseId : '') || '');

export function managementDashboardCounts(records, classes, parentKey = 'courseId') {
  const classById = new Map(classes.map((item) => [String(item.id), item]));
  const classCounts = new Map();
  const parentCounts = new Map();
  for (const record of records) {
    const classId = String(record.classId || '');
    const parentId = managementParentId(record, classById, parentKey);
    classCounts.set(classId, (classCounts.get(classId) || 0) + 1);
    parentCounts.set(parentId, (parentCounts.get(parentId) || 0) + 1);
  }
  return { classCounts, parentCounts };
}
